import React from "react";
import Desktop from "./desktop";

const Mobile = ({ viewModel }) => {
  return <Desktop viewModel={viewModel} isMobile />;
};

export default Mobile;
